'use es6';

import { each, range } from 'underscore';
import * as FieldConstants from 'EmailEditorUI/constants/FieldConstants';
import { Map as ImmutableMap, List as ImmutableList } from 'immutable';
import { uniqueId } from 'underscore';
import { getPaddingCss, getDefaultModuleIds } from 'EmailEditorUI/utils/moduleUtils';
import { MODULE_PADDING_FLAG_KEY, MODULE_PADDING_CSS_KEY } from 'EmailEditorUI/utils/dragDropModuleConstants';
function setDefaults(fields, newEl, userDefaults, key = ['body']) {
  let leftoverDefaults = userDefaults;
  fields.forEach(f => {
    const newKey = key.concat(f.name);
    const defaultsKey = newKey.slice(1); // Drop 'body' from the beginning of the key
    if (f.type === FieldConstants.GROUP) {
      if (userDefaults.hasIn(defaultsKey) && userDefaults.getIn(defaultsKey) !== null) {
        newEl = newEl.setIn(newKey, userDefaults.getIn(defaultsKey));
      } else if (f.occurrence && f.default) {
        newEl = newEl.setIn(newKey, f.default);
      } else if (f.occurrence) {
        newEl = newEl.setIn(newKey, ImmutableList());
        each(range(f.occurrence.default), defaultIndex => {
          newEl = setDefaults(f.children, newEl, leftoverDefaults, newKey.concat(defaultIndex));
        });
      } else {
        newEl = setDefaults(f.children, newEl, leftoverDefaults, newKey);
      }
    } else {
      if (userDefaults.hasIn(defaultsKey) && userDefaults.getIn(defaultsKey) !== null) {
        if (f.occurrence) {
          newEl = newEl.setIn(newKey, ImmutableList());
          each(range(f.occurrence.default), defaultIndex => {
            newEl = newEl.setIn([newKey.concat(defaultIndex), userDefaults.getIn(defaultsKey)]);
          });
        } else {
          newEl = newEl.setIn(newKey, userDefaults.getIn(defaultsKey));
        }
      }
    }
    leftoverDefaults = leftoverDefaults.removeIn(defaultsKey);
  });
  if (!leftoverDefaults.isEmpty()) {
    newEl = newEl.update('body', body => body.merge(leftoverDefaults.toJS()));
  }
  if (newEl.hasIn(['body', MODULE_PADDING_FLAG_KEY])) {
    newEl = newEl.setIn(['body', MODULE_PADDING_CSS_KEY], getPaddingCss(newEl.getIn(['body', MODULE_PADDING_FLAG_KEY])));
  }
  return newEl;
}
export function generateElementId() {
  return uniqueId(`module_${Date.now()}`);
}
export function generateSectionId() {
  return uniqueId(`section_${Date.now()}`);
}
export function generateElement(moduleSpec, id, userDefaults = ImmutableMap()) {
  const moduleId = moduleSpec.moduleId;
  const paddingField = moduleSpec.fields.find(f => f.name === MODULE_PADDING_FLAG_KEY);
  let element = ImmutableMap({
    id,
    name: id,
    type: 'module',
    module_id: moduleSpec.moduleId,
    path: moduleSpec.path,
    body: ImmutableMap({
      hs_enable_module_padding: paddingField && paddingField.locked ? paddingField.default : getDefaultModuleIds().includes(moduleId)
    })
  });
  if (!moduleSpec.global) {
    element = setDefaults(moduleSpec.fields, element, userDefaults);
  }
  if (moduleSpec.smartObjects && !!moduleSpec.definitionId) {
    element = element.set('smart_objects', moduleSpec.get('smartObjects').map(s => s.set('body', ImmutableMap({
      html: s.get('html')
    })))).set('definition_id', moduleSpec.definitionId).set('smart_type', moduleSpec.smartType);
  }
  element = element.set('custom_widget_data', moduleSpec);
  return element.toJS();
}
export const sanitizeSections = (sections, elements) => {
  return sections.map(s => s.update('columns', columns => columns.map(c => c.update('widgets', widgets => widgets.filter(w => elements.has(w))))));
};
export const generateUniqueIdsForSectionAssets = (section, widgets) => {
  const idMapper = {};
  const widgetKeys = Object.keys(widgets.toJS());
  let newWidgets = ImmutableMap();
  widgetKeys.forEach(k => {
    idMapper[k] = generateElementId();
    newWidgets = newWidgets.set(idMapper[k], widgets.get(k).set('id', idMapper[k]).set('name', idMapper[k]));
  });
  const newSection = section.update('columns', cols => {
    return cols.map((c, index) => {
      c = c.set('id', `column-${Date.now()}-${index}`);
      return c.update('widgets', colWidgets => colWidgets.map(w => idMapper[w]));
    });
  }).set('id', generateSectionId());
  return {
    section: newSection,
    widgets: newWidgets
  };
};